// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getAll() {
            const response = await axios.get(`${MAIN_API}/api/admin/account/all`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getAllUsers() {
            const response = await axios.get(`${MAIN_API}/api/admin/account/all/users`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async createUser(_, data) {
            const response = await axios.post(`${MAIN_API}/api/admin/account/create`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async updateUser(_, data) {
            const response = await axios.put(`${MAIN_API}/api/admin/account/update/${data.id}`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getAllPartners() {
            const response = await axios.get(`${MAIN_API}/api/partner`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getPartnerById(_, id) {
            const response = await axios.get(`${MAIN_API}/api/partner/info/${id}`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async createPartner(_, data) {
            const response = await axios.post(`${MAIN_API}/api/partner/create`, data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            return response.data
        },
        async updatePartner(_, data) {
            const response = await axios.put(`${MAIN_API}/api/partner/update/${data.id}`, data, {
                headers: { 'Content-Type': 'application/json' },
            })
            return response.data
        },
        async getCities() {
            const response = await axios.get(`${MAIN_API}/api/city`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
    },
    getters: {
    }
}
